export default function headerFunctionality() {
  hideCartWhenNotLoggedIn();
  showSearchHeader();
}

function hideCartWhenNotLoggedIn() {
  if (!$('body').hasClass('logged-in')) {
    $('.header-mini-info-bar').css('visibility', 'hidden');
  }
}

function showSearchHeader() {
  $('.search-icon').click(function() {
    $('.show-search').toggleClass('open');
  });
}
